// Override ember-composable-helpers' flatten with our custom version
// that supports EmberData PromiseManyArray
export { default } from 'bullitttime-embercomponents/helpers/flatten';
